import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { ExportDialogModule } from '@core/components/export-dialog/export-dialog.module';
import { FcCustomBadgeModule } from '@core/components/fc-custom-badge/fc-custom-badge.module';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { FuseSidebarModule } from '@fuse/components/sidebar/sidebar.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DialogGroupsModule } from './dialogs/dialog-groups.module';
import { FilterGroupsModule } from './filter/filter-groups.module';
import { GroupsComponent } from './groups.component';
import { GroupService } from './services/groups-api.service';

const routes: Routes = [
  {
    path: 'grupos',
    component: GroupsComponent,
    pathMatch: 'full',
    canActivate: [
      AuthenticatedGuard,
    ],
    data: { title: 'CORE.SERVICES.NAVIGATION.SETTINGS.GROUPS' }
  }
];

@NgModule({
  declarations: [
    GroupsComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    TranslateModule,
    FuseSharedModule,
    FuseSidebarModule,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    FilterGroupsModule,
    DialogGroupsModule,
    FcCustomBadgeModule,
    ExportDialogModule
  ],
  exports: [
    GroupsComponent
  ],
  providers: [
    GroupService,
  ]
})

export class GroupsModule {}
